import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

class RedirectUriCell extends Component {

  static propTypes = {
    className: PropTypes.string,
    onOidcRedirectUrisUpdate: PropTypes.func,
    cellData: PropTypes.shape({
      id: PropTypes.number,
      type: PropTypes.string,
      value: PropTypes.string,
      placeholder: PropTypes.string,
    }),
  }

  handleValueChange = (e) => {
    this.props.onOidcRedirectUrisUpdate(e.target.value);
  };

  render() {
    return (
      <input className={this.props.className}
             type='text'
             id={this.props.cellData.id}
             name={this.props.cellData.type}
             value={this.props.cellData.value}
             placeholder={this.props.cellData.placeholder}
             onChange={this.handleValueChange}/>
    );
  };
}

export default RedirectUriCell;
